module.exports = __webpack_public_path__ + "img/composite1.f21f7714.png";